module.exports = __webpack_public_path__ + "static/media/crocodile(2).ca85f69a.PNG";